var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor-pointer h-4 relative w-5"},[_c('span',{staticClass:"absolute bg-grey-100 block duration-200 h-px w-full",class:{
      'top-0': !_vm.isNavigationOpened,
      'top-1/2 opacity-100 rotate-40': _vm.isNavigationOpened,
    }}),_vm._v(" "),_c('span',{staticClass:"absolute bg-grey-100 block duration-200 h-px top-1/2",class:{
      'w-full': !_vm.isNavigationOpened,
      'top-1/2 opacity-0 w-0': _vm.isNavigationOpened,
    }}),_vm._v(" "),_c('span',{staticClass:"absolute bg-grey-100 block duration-200 h-px w-full",class:{
      'top-full': !_vm.isNavigationOpened,
      'top-1/2 opacity-100 rotate-40': _vm.isNavigationOpened,
    }})])}
var staticRenderFns = []

export { render, staticRenderFns }